import "./Experience.css";
import { EXPERIENCE, SECTIONS } from "../../data";

export default function Experience() {
  const renderExperienceCard = (experience) => {
    const { company, position, period, description, tools } = experience;

    return (
      <div className="experience-card">
        <h2>{company}</h2>
        <div className="position-detail">
          <h3>{position}</h3>
          <h4>
            {period.start} - {period.end}
          </h4>
        </div>

        <ul className="description-ul">
          {description.map((desc, index) => (
            <li className="description-li" key={index}>
              {desc}
            </li>
          ))}
        </ul>

        <ul className="tools-ul">
          {tools.map((tool, index) => (
            <li className="tools-li" key={index}>
              {tool}
            </li>
          ))}
        </ul>
      </div>
    );
  };
  return (
    <div className="experience-container" id={SECTIONS.EXPERIENCE}>
      <h1 className="experience-title">Experience</h1>
      {EXPERIENCE.map(renderExperienceCard)}
    </div>
  );
}
